import { useQuery } from '@tanstack/react-query';

import { QueryKey } from ':cloud/queries/types';
import { APIClientBase } from ':cloud/state/Api';
import { BuildQuestItem, GetBuildQuestStatusResponse } from ':cloud/types/service_proto';

async function fetchQuestions(userId: string): Promise<GetBuildQuestStatusResponse> {
  const path = `organization-management/v1/users/${userId}/quest/status`;
  const { data } = await APIClientBase.get<GetBuildQuestStatusResponse>(path);
  return data;
}

export function useGetBuildQuestQuestions(userId: string): {
  isLoading: boolean;
  items: BuildQuestItem[];
} {
  const { isLoading, data } = useQuery<GetBuildQuestStatusResponse, Error>({
    queryKey: [QueryKey.buildQuest, userId],
    queryFn: async () => fetchQuestions(userId),
    enabled: !!userId,
    staleTime: Infinity,
  });

  return {
    isLoading,
    items: data?.items ?? [],
  };
}
